import React, { useEffect, useState } from 'react';
import Routing from './routing';
import Preloader from './components/preloader';
import PopupAd from './components/popupad';

const BOOT_MIN_MS = 1400;
const EXIT_MS = 550;

const App = () => {
  const [bootPhase, setBootPhase] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    const timers = [];

    const startExit = () => {
      if (cancelled) return;
      setBootPhase('exit');
      timers.push(window.setTimeout(() => {
        if (!cancelled) setBootPhase('done');
      }, EXIT_MS));
    };

    const minDelay = new Promise((resolve) => {
      timers.push(window.setTimeout(resolve, BOOT_MIN_MS));
    });

    const pageReady = new Promise((resolve) => {
      if (document.readyState === 'complete') {
        resolve();
        return;
      }
      window.addEventListener('load', resolve, { once: true });
    });

    const fontsReady = document.fonts?.ready?.catch(() => undefined) ?? Promise.resolve();

    Promise.all([minDelay, pageReady, fontsReady]).then(startExit);

    return () => {
      cancelled = true;
      timers.forEach((id) => clearTimeout(id));
    };
  }, []);

  return (
    <>
      {bootPhase !== 'done' ? <Preloader variant="boot" exiting={bootPhase === 'exit'} /> : null}
      <Routing />
      {bootPhase === 'done' && <PopupAd />}
    </>
  );
};

export default App;
